<script lang="jsx">
import { linkTo, hPost } from "@osgfe/tools";
import { Platform } from "@osgfe/jiemo-base"; // 主要是兼容 数据、芥末 不同形态 -- 那是不是也可以兼容 vss/lps/rss？
import XxMainLayout from "../../components/MainLayout.vue";
import { PikeConnection } from "../../utils/pike";

export default {
  name: "XxPlatform",
  components: {
    XxMainLayout,
  },
  data() {
    return {
      pikeInstance: null,
      noticeIdSet: new Set(),
      NOTICE_STATUS: {
        READ: 30,
        CLOSED: 20,
      },
    };
  },
  computed: {
    isRTL() {
      return this.$i18nClient.getCurrentLocale() === "ar";
    },
  },
  mounted() {
    this.updateRTLStyle(this.isRTL);
    this.startPike();
    this.checkRealSupplierId();
  },
  methods: {
    changeNoticeStatus(noticeRecordId, readStatus) {
      try {
        const supplierId = window.localStorage.getItem("rss_supplier_id");
        hPost(
          "/api/s/peisong/rideroms/supplier/notice/record/readstatus/modify",
          { noticeRecordId, readStatus, supplierId },
          { headers: { "mall-login-type": "passport" } }
        );
      } catch (error) {
        //
      }
    },
    startPike(mis) {
      if (this.pikeInstance) {
        return;
      }
      console.log("startPike");
      PikeConnection.init(mis).then((pikeInstance) => {
        this.pikeInstance = pikeInstance;
        pikeInstance.onMessage((data, message) => {
          // console.log(data, message);
          if (data) {
            const noticeInfo = JSON.parse(data);
            if (!noticeInfo || !noticeInfo.noticeRecordId) {
              return;
            }
            // 已存在通知，则不重复展示
            if (this.noticeIdSet.has(noticeInfo.noticeRecordId)) {
              return;
            }
            this.noticeIdSet.add(noticeInfo.noticeRecordId);
            const isDownload = noticeInfo.noticeType === 4;
            let content = isDownload ? "" : noticeInfo.content;
            if (content && content.length > 20) {
              content = `${content.substring(0, 20)}...`;
            }
            const dateStr = noticeInfo.notificationSendTimeStr;
            let isAutoClose = false;
            let title =
              noticeInfo.title?.length > 12
                ? `${noticeInfo.title.substring(0, 12)}...`
                : noticeInfo.title;

            const notice = this.$mtd.notify({
              type: "info",
              title,
              offset: Math.max(window.innerHeight - 180, 50),
              message: isDownload
                ? this.$createElement("div", {}, [
                    this.$createElement("div", {}, dateStr),
                    this.$createElement(
                      "a",
                      {
                        style: {
                          float: this.isRTL ? "left" : "right",
                          marginInlineEnd: "10px",
                          color: "#00b85c",
                          cursor: "pointer",
                        },
                        on: {
                          click: () => {
                            isAutoClose = true;
                            linkTo(
                              noticeInfo.content,
                              {},
                              { target: "_blank" }
                            );
                            this.changeNoticeStatus(
                              noticeInfo.noticeRecordId,
                              this.NOTICE_STATUS.READ
                            );
                            notice && notice.close();
                          },
                        },
                      },
                      this.$getText("O_Download_i54A", { defaultValue: "下载" })
                    ),
                  ])
                : this.$createElement("div", {}, [
                    this.$createElement("div", {}, dateStr),
                    content,
                    this.$createElement(
                      "a",
                      {
                        style: {
                          float: this.isRTL ? "left" : "right",
                          marginInlineEnd: "10px",
                          color: "#00b85c",
                          cursor: "pointer",
                        },
                        on: {
                          click: () => {
                            isAutoClose = true;
                            linkTo(
                              "/courier/notice/detail.html",
                              {
                                id: noticeInfo.noticeRecordId,
                              },
                              { target: "_blank" }
                            );
                            notice && notice.close();
                          },
                        },
                      },
                      this.$getText("O_View_b4aZ", { defaultValue: "查看" })
                    ),
                  ]),
              duration: 0,
              onClose: () => {
                if (!isAutoClose) {
                  this.changeNoticeStatus(
                    noticeInfo.noticeRecordId,
                    this.NOTICE_STATUS.CLOSED
                  );
                }
                this.noticeIdSet.delete(noticeInfo.noticeRecordId);
              },
            });
          }
        });
      });
    },
    updateRTLStyle(isRTL) {
      const htmlNode = document.documentElement;
      if (isRTL) {
        return htmlNode && htmlNode.setAttribute("dir", "rtl");
      }
      return htmlNode && htmlNode.setAttribute("dir", "");
    },
    checkRealSupplierId() {
      window.localStorage.setItem(
        "rss_real_supplier_id",
        window.localStorage.getItem("rss_supplier_id")
      );
    },
  },
  render(h) {
    return new Platform({
      // appConfigs: {
      //   rss: {
      //     matcher: /\/(rss\/)?([a-zA-Z]+)\/(.*)/,
      //     replacer(originPath) {
      //       const [, mcFlag, projectFlag, subPath] = originPath.match(
      //         this.matcher
      //       );
      //       console.log("path---", originPath, mcFlag, projectFlag, subPath);
      //       return originPath;
      //     },
      //   },
      // },
      render() {
        return <xx-main-layout />;
      },
    }).mount(h);
  },
};
</script>
